import store from "@/store";
export const BNB = store.state.netWorkConfig.TokenBNB

